module.exports = __webpack_public_path__ + "resources/img/img_sqml_di1_jp.80aa2b72890d377d40ab19cf920199eb.png";